var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
// You can declare mixins as the same style as components.
let SwUpdate = class SwUpdate extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isShowingSwUpdateAlert = false;
        this.swUpdateRegistration = null;
        // #endregion
        // #region Async methods (api calls only)
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    created() {
        this.onCreated();
    }
    // #endregion
    // #region Lifecycle Hook handlers
    onCreated() {
        this.initializeSwUpdate();
    }
    // #endregion
    // #region Watcher handlers
    // #endregion
    // #region Class handlers
    onSwUpdateAlertHide() {
        this.swUpdateHide();
    }
    onSwUpdateAlertRefresh() {
        this.swUpdateRefresh();
    }
    // #endregion
    // #region Class methods
    initializeSwUpdate() {
        // Listen for our custom event from the SW registration
        document.addEventListener('swUpdated', this.swUpdateAvailable);
    }
    swUpdateAvailable(_event) {
        // this.swUpdateRegistration = (event as SwUpdatedEvent).detail;
        this.isShowingSwUpdateAlert = true;
    }
    swUpdateHide() {
        this.isShowingSwUpdateAlert = false;
        this.$store.dispatch('openDialog', {
            title: this.$tc('Manually Refresh'),
            text: `${this.$tc('Working with an old version may cause unexpected issues.')} ${this.$tc('When done with your work please close this window; or, refresh the page by using CTRL + F5 on a Windows device or CMD + R on an iOS (Apple) device.')}`,
            buttons: {
                confirm: {
                    text: this.$tc('Close'),
                    action: () => {
                    },
                },
            },
        });
    }
    swUpdateRefresh() {
        this.isShowingSwUpdateAlert = false;
        window.location.reload(true);
    }
};
SwUpdate = __decorate([
    Component
], SwUpdate);
export { SwUpdate };
// #endregion
// #region Constants
// #endregion
